import React, { useEffect, useContext, useState, useRef } from "react";
import { GlobalContext } from "../../../App";
import L from "leaflet";
import "./MapTemplate.css";
import { HOST, HOST_MEDIA_URL } from "../../host";
import html2canvas from "html2canvas";
import { Rnd } from "react-rnd";

export default function MapTemplate({ editingElementId, setEditingElementId, elements, setElements, removeLegend ,legendHtmlItems}) {
  const [selState, setSelState] = useState("");
  const [selDistrict, setSelDistrict] = useState("");
  const [stateNames, setStateNames] = useState([]);
  const [districtNames, setDistrictNames] = useState([]);
  const [allDistrictFeatures, setAllDistrictFeatures] = useState([]);
  const [stateFeatures, setStateFeatures] = useState([]);
  const { userInfo, map, Canvas } = useContext(GlobalContext);
  const mapRefs = useRef({});
  const tehsilLayerRef = useRef(null);
  const stateLayerRef = useRef(null);
  const districtLayerRef = useRef(null);
  const [mapPreviewImage, setMapPreviewImage] = useState(null);
  const [tehsilNames, setTehsilNames] = useState([]);
  const [selTehsil, setSelTehsil] = useState("");
  const [tehsilFeatures, setTehsilFeatures] = useState([]);
  const [showStateMap, setShowStateMap] = useState(false);
  const [showDistrictMap, setShowDistrictMap] = useState(false);
  const [showTehsilMap, setShowTehsilMap] = useState(false);
  const [loader, setLoader] = useState(false);
  const [indiaBoundary, setIndiaBoundary] = useState(null);
  const [showLegendContainer, setShowLegendContainer] = useState(true);

  const indiaLayerRef = useRef(null);

  console.log("userInfo", userInfo);

  useEffect(() => {
    if (map) {
      const handleBaseLayerChange = (e) => updateMiniMaps(e.layer);
      map.on("baselayerchange", handleBaseLayerChange);

      const initialLayer = Object.values(map._layers).find(
        (l) => l instanceof L.TileLayer && map.hasLayer(l)
      );
      updateMiniMaps(initialLayer);

      fetchStateDistrict();

      fetchIndiaBoundary();

      return () => {
        map.off("baselayerchange", handleBaseLayerChange);
      };
    }
  }, [map]);

  useEffect(() => {
  if (elements.some((el) => el.type === "2")) {
    setShowLegendContainer(true);
  }
}, [elements]);


  useEffect(() => {
    if (!map) return;

    const captureMap = () => {
      const controls = document.querySelectorAll(
        ".leaflet-top, .leaflet-bottom"
      );
      controls.forEach((el) => (el.style.display = "none"));

      const target = document.querySelector(".leaflet-container");
      const map4Container = document.getElementById("map4");

      if (target && map4Container) {
        const rect = map4Container.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();

        // calculate offsets so we capture the region behind #map4
        const offsetX = rect.left - targetRect.left;
        const offsetY = rect.top - targetRect.top;

        html2canvas(target, {
          useCORS: true,
          allowTaint: true,
          backgroundColor: null,
          x: offsetX,
          y: offsetY,
          width: rect.width,
          height: rect.height,
          scale: 2,
        })
          .then((canvas) => {
            const dataUrl = canvas.toDataURL("image/png");
            setMapPreviewImage(dataUrl);
            controls.forEach((el) => (el.style.display = ""));
          })
          .catch((err) => {
            console.error("Map capture failed:", err);
            controls.forEach((el) => (el.style.display = ""));
          });
      }
    };

    const updatePreview = () => {
      setTimeout(() => captureMap(), 0); // small async delay to ensure tiles render
    };

    const onTilesLoaded = () => {
      captureMap();
    };

    map.whenReady(() => {
      updatePreview();

      map.on("moveend", updatePreview);
      map.on("zoomend", updatePreview);
      map.on("layeradd", updatePreview); // optional
      map.on("tileload", onTilesLoaded);
    });

    return () => {
      map.off("moveend", updatePreview);
      map.off("zoomend", updatePreview);
      map.off("layeradd", updatePreview);
      map.off("tileload", onTilesLoaded);
    };
  }, [map]);


  const updateMiniMaps = (baseLayer) => {
    const center = [27.891535, 78.078743];
    const zoom = 4.0;
    const mapIds = ["map1", "map2", "map3"];

    mapIds.forEach((id) => {
      const container = L.DomUtil.get(id);
      if (container && container._leaflet_id) {
        container._leaflet_id = null;
      }

      const miniMap = L.map(id, {
        zoomControl: false,
        attributionControl: false,
      }).setView(center, zoom);

      let clonedBaseLayer;

      try {
        if (!baseLayer._url) {
          clonedBaseLayer = L.tileLayer("data:image/svg+xml;base64,...", {
            maxZoom: 20,
            zIndex: 1000,
          });
        } else {
          clonedBaseLayer = L.tileLayer(baseLayer._url, {
            ...baseLayer.options,
          });
        }

        clonedBaseLayer.addTo(miniMap);
      } catch (err) {
        console.warn("Error cloning baseLayer in MapTemplate:", err);
      }

      // Conditionally add extra layers
      // if (id === "map1") {
      //   fetchAndAddLayer(miniMap, 195);
      // } else if (id === "map2") {
      //   fetchAndAddLayer(miniMap, 196);
      // }

      mapRefs.current[id] = miniMap;
    });
  };

  const fetchAndAddLayer = async (mapInstance, datasetId) => {
    const data = {
      dataset: datasetId === 195 ? "State Boundaries" : "District Boundaries",
      dates: [null, null],
      project: "global",
      memb: userInfo.id,
      tab: "opt1",
    };

    try {
      const res = await fetch(`${HOST}/sat-geo/${datasetId}`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ data }),
      });

      const result = await res.json();
      if (result?.url) {
        const overlay = L.tileLayer(result.url, {
          maxZoom: 20,
          zIndex: 1005,
        });
        overlay.addTo(mapInstance);
      }
    } catch (err) {
      console.error(`Error loading sat-geo/${datasetId}`, err);
    }
  };


  const fetchIndiaBoundary = async () => {
    try {
      const res = await fetch(
        `${HOST_MEDIA_URL}/media/India_Country_Boundary/India_Countary_Boundary.geojson`
      );
      const data = await res.json();

      setIndiaBoundary(data);

      const map1 = mapRefs.current["map1"];
      if (!map1) return;

      if (indiaLayerRef.current) {
        map1.removeLayer(indiaLayerRef.current);
      }

      const indiaLayer = L.geoJSON(data, {
        style: {
          color: "black",
          weight: 2,
          fillOpacity: 0.1,
        },
      }).addTo(map1);

      map1.flyToBounds(indiaLayer.getBounds());
      indiaLayerRef.current = indiaLayer;
    } catch (err) {
      console.error("Failed to load India boundary:", err);
    }
  };

  const fetchStateDistrict = async () => {
    setLoader(true);
    try {
      const res = await fetch(`${HOST}/get-map-boundaries`);
      const result = await res.json();
      console.log("result", result);
      if (result) setLoader(false);
      // Store all state names
      const uniqueStates = [
        ...new Set(result.state.features.map((f) => f.properties.State_Name)),
      ];
      setStateNames(uniqueStates);
      setStateFeatures(result.state.features);

      // Just store all districts here, don't filter yet
      setAllDistrictFeatures(result.district.features);
    } catch (err) {
      console.error("Error fetching state-district", err);
      setLoader(false);
    }
  };


  const fetchTehsilsForDistrict = async (districtName, stateName) => {
    setLoader(true);
    try {
      const res = await fetch(`${HOST}/get-tehsils-by-district`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ district: districtName, state: stateName }),
      });

      console.log("Tehsil fetch status:", res.status, res.ok);
      const data = await res.json();
      console.log("Filtered tehsils:", data);

      if (data) setLoader(false);

      const uniqueTehsils = [
        ...new Set(data.features.map((f) => f.properties.TEHSIL)),
      ];
      setTehsilNames(uniqueTehsils);
      setTehsilFeatures(data.features);

      const map3 = mapRefs.current["map3"];
      if (!map3) {
        console.warn("Map3 not initialized yet.");
        return;
      }

      // Remove previous tehsil layer
      if (map3._tehsilLayer) {
        map3.removeLayer(map3._tehsilLayer);
      }

      // const tehsilLayer = L.geoJSON(data, {
      //   style: {
      //     color: "black",
      //     weight: 2,
      //     fillOpacity: 0.3,
      //   },
      //   onEachFeature: (feature, layer) => {
      //     const name =
      //       feature.properties.TEHSIL ||
      //       feature.properties.Sub_dist ||
      //       "Unknown";
      //     layer.bindPopup(`<strong>${name}</strong>`);
      //   },
      // }).addTo(map3);

      // Canvas.addLocalLayer('tehsil boundary', tehsilLayer, 'red', null, false)

      // map3._tehsilLayer = tehsilLayer;
      // map3.fitBounds(tehsilLayer.getBounds());
    } catch (err) {
      console.error("Failed to fetch tehsils:", err);
      setLoader(false);
    }
  };

  // const highlightState = (selectedState) => {
  //   const map1 = mapRefs.current["map1"];
  //   if (!map1) return;

  //   if (stateLayerRef.current) {
  //     map1.removeLayer(stateLayerRef.current);
  //   }

  //   const feature = stateFeatures.find(
  //     (f) => f.properties.State_Name === selectedState
  //   );
  //   if (feature) {
  //     const layer = L.geoJSON(feature, {
  //       style: { color: "blue", weight: 2, fillOpacity: 0.3 },
  //     });
  //     layer.addTo(map1);
  //     map1.fitBounds(layer.getBounds());
  //     stateLayerRef.current = layer;
  //   }
  // };

  const highlightState = (selectedState) => {
    const map1 = mapRefs.current["map1"];
    if (!map1) return;
  
    if (stateLayerRef.current) {
      map1.removeLayer(stateLayerRef.current);
    }
  
    const feature = stateFeatures.find(
      (f) => f.properties.State_Name === selectedState
    );
    if (feature) {
      const layer = L.geoJSON(feature, {
        style: { color: "blue", weight: 2, fillOpacity: 0.3 },
      }).addTo(map1);
  
      // map1.flyToBounds(layer.getBounds());
      stateLayerRef.current = layer;
    }
  };
  
  const highlightDistrict = (selectedDistrict, selectedState) => {
    const map2 = mapRefs.current["map2"];
    if (!map2) return;
  
    // Remove previous district layer
    if (districtLayerRef.current) {
      map2.removeLayer(districtLayerRef.current);
    }
  
    const feature = allDistrictFeatures.find(
      (f) =>
        f.properties.Dist_Name === selectedDistrict &&
        f.properties.State_Name === selectedState
    );
  
    if (feature) {
      // First draw the whole state in map2
      const stateFeature = stateFeatures.find(
        (f) => f.properties.State_Name === selectedState
      );
      const stateLayer = L.geoJSON(stateFeature, {
        style: { color: "blue", weight: 2, fillOpacity: 0.2 },
      }).addTo(map2);
  
  
      // Then draw the selected district
      const districtLayer = L.geoJSON(feature, {
        style: { color: "red", weight: 2, fillOpacity: 0.3 },
      }).addTo(map2);
  
      map2.fitBounds(stateLayer.getBounds());
      districtLayerRef.current = districtLayer;
    }
  };
  
  
  const highlightTehsil = (tehsilName) => {
    const map3 = mapRefs.current["map3"];
    if (!map3) return;
  
    // Find the matching feature by name
    const feature = tehsilFeatures.find(
      (f) =>
        f.properties.TEHSIL?.trim().toLowerCase() ===
          tehsilName.trim().toLowerCase() ||
        f.properties.Sub_dist?.trim().toLowerCase() ===
          tehsilName.trim().toLowerCase()
    );
  
    if (!feature) {
      console.warn("Tehsil feature not found for:", tehsilName);
      return;
    }
  
    // First draw the selected district in map3
    const districtFeature = allDistrictFeatures.find(
      (f) => f.properties.Dist_Name === selDistrict && f.properties.State_Name === selState
    );
    const districtLayer = L.geoJSON(districtFeature, {
      style: { color: "red", weight: 2, fillOpacity: 0.2 },
    }).addTo(map3);
 
    // Then draw the selected tehsil
    L.geoJSON(feature, {
      style: { color: "green", weight: 2, fillOpacity: 0.4 },
      onEachFeature: (feature, layer) => {
        const name =
          feature.properties.TEHSIL || feature.properties.Sub_dist || "Tehsil";
        layer.bindPopup(`<strong>${name}</strong>`);
      },
    }).addTo(map3);
  
    map3.fitBounds(districtLayer.getBounds());
  };

  return (
    <>
      <div className="location-map-template-inner-container">
        <div className="maptemplate-flex-row">
          {/* Left column with 3 maps */}

          <div className="maptemplate-left-column">
            {!showStateMap ? (
              <div style={{ position: "relative", display: "inline-block" }}>
                <select
                  className="form-select custom-select"
                  value={selState}
                  onChange={(e) => {
                    const selected = e.target.value;
                    setSelState(selected);
                    setSelDistrict("");
                    setShowStateMap(true);
                    const uniqueDistricts = [
                      ...new Set(
                        allDistrictFeatures
                          .filter((f) => f.properties.State_Name === selected)
                          .map((f) => f.properties.Dist_Name)
                      ),
                    ];
                    setDistrictNames(uniqueDistricts);
                    //  Highlight state on map1
                    highlightState(selected);
                  }}
                  style={{ width: loader ? '85%' : '100%' }}
                >
                  <option value="">Select State</option>
                  {stateNames.map((state) => (
                    <option key={state} value={state}>
                      {state}
                    </option>
                  ))}
                </select>
                {loader && (
                  <div
                    className="lds-dual-ring"
                    style={{
                      position: "absolute",
                      left: "90%",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  >
                    <i className="fa-solid fa-globe"></i>
                  </div>
                )}
              </div>
            ) : (
              <>
                <button className="map-action-btn"
                  onClick={() => {
                    setShowStateMap(false);
                  }}
                >
                  change
                </button>
              </>
            )}

            <div className="section-map" id="map1"></div>

            {!showDistrictMap ? (
              <select
                className="form-select custom-select"
                value={selDistrict}
                onChange={(e) => {
                  const selected = e.target.value;
                  setSelDistrict(selected);
                  setShowDistrictMap(true);
                  fetchTehsilsForDistrict(selected, selState);
                  //  Highlight district on map2
                  highlightDistrict(selected, selState);
                }}
                disabled={!selState}
              >
                <option value="">Select District</option>
                {districtNames.map((district, idx) => (
                  <option key={idx} value={district}>
                    {district}
                  </option>
                ))}
              </select>
            ) : (
              <>
                <button className="map2-action-btn"
                  onClick={() => {
                    setShowDistrictMap(false);
                  }}
                >
                  change
                </button>
              </>
            )}
            <div className="section-map" id="map2"></div>

            {!showTehsilMap ? (
              <div style={{ position: "relative", display: "inline-block" }}>
                <select
                  className="form-select custom-select"
                  value={selTehsil}
                  onChange={(e) => {
                    const selected = e.target.value;
                    setSelTehsil(selected);
                    setShowTehsilMap(true);
                    highlightTehsil(selected);
                  }}
                  disabled={!selDistrict}
                  style={{ width: loader ? '85%' : '100%' }}
                >
                  <option> Select Tehsil </option>
                  {tehsilNames.map((tehsil) => (
                    <option key={tehsil} value={tehsil}>
                      {tehsil}
                    </option>
                  ))}
                </select>
                {loader && (
                  <div
                    className="lds-dual-ring"
                    style={{
                      position: "absolute",
                      left: "90%",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  >
                    <i className="fa-solid fa-globe"></i>
                  </div>
                ) }
              </div>
            ) : (
              <>
                <button className="map3-action-btn"
                  onClick={() => {
                    setShowTehsilMap(false);
                  }}
                >
                  change
                </button>
              </>
            )}
            <div className="section-map" id="map3"></div>
          </div>

          {/* Right column with a full-size map */}
          <div className="maptemplate-right-column">
            <div
              className="section-map-full"
              id="map4"
              style={{ position: "relative" }}
            >
              {mapPreviewImage && (
                <img
                  src={mapPreviewImage}
                  alt="Map preview"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    position: "absolute",
                    zIndex: 0,
                  }}
                />
              )}

              {/* Render overlay elements */}
              {elements
                .filter((el) => el.type !== "2") // exclude legend items
                .map((el, index) => (
                  <Rnd
                    key={el.id}
                    default={{
                      x: el.x,
                      y: el.y,
                      width: "fit-content",
                      height: "fit-content",
                    }}
                    bounds={el.type === "northArrow" ? "#map4" : "parent"}   // make draggable across full map
                    onDragStop={(e, d) => {
                      setElements((prev) =>
                        prev.map((item) =>
                          item.id === el.id ? { ...item, x: d.x, y: d.y } : item
                        )
                      );
                    }}
                    style={{ zIndex: 1000 }}
                  >
                    <div
                      id={el.id}
                      onClick={(e) => {
                        e.stopPropagation();
                        setEditingElementId(el.id);
                      }}
                    >
                      {el.type === "1" ? (
                        editingElementId === el.id ? (
                          <div>
                            <input
                              type="text"
                              value={el.content.title}
                              placeholder="Title"
                              className="form-control mb-2"
                              style={{
                                backgroundColor: "white",
                                color: "black",
                                border: "1px solid black",
                              }}
                              onChange={(e) => {
                                const newElements = [...elements];
                                const updatedElement = { ...newElements[index] };
                                updatedElement.content = {
                                  ...updatedElement.content,
                                  title: e.target.value,
                                };
                                newElements[index] = updatedElement;
                                setElements(newElements);
                              }}
                              autoFocus
                            />
                            <input
                              type="text"
                              value={el.content.subtitle}
                              placeholder="Subtitle"
                              className="form-control"
                              style={{
                                backgroundColor: "white",
                                color: "black",
                                border: "1px solid black",
                              }}
                              onChange={(e) => {
                                const newElements = [...elements];
                                const updatedElement = { ...newElements[index] };
                                updatedElement.content = {
                                  ...updatedElement.content,
                                  subtitle: e.target.value,
                                };
                                newElements[index] = updatedElement;
                                setElements(newElements);
                              }}
                            />
                          </div>
                        ) : (
                          <div
                            style={{
                              backgroundColor: "rgba(255, 255, 255, 0.8)",
                              padding: "10px 15px",
                              border: "2px solid black",
                            }}
                          >
                            <div style={{ fontWeight: "bold", fontSize: "20px" }}>
                              {el.content.title}
                            </div>
                            <div style={{ fontSize: "15px" }}>
                              {el.content.subtitle}
                            </div>
                          </div>
                        )
                      ) : (
                        el.content
                      )}
                    </div>
                  </Rnd>
                ))}

              {/* 🔹 Render the legend ONCE if legend items exist */}
              {/* {elements.some((el) => el.type === "2") && (
                <Rnd
                  key="legend"
                  id="legend-container"
                  default={{
                    x: 10,
                    y: 10,
                    width: "fit-content",
                    maxWidth: "180px",
                    height: "fit-content",
                  }}
                  bounds="#map4"   // draggable across full map
                  style={{
                    position: "absolute",
                    zIndex: 1000,
                    border: "2px solid black",
                    backgroundColor: "rgba(255, 255, 255, 0.8)",
                    padding: "10px 15px",
                    width: "200px",
                    maxWidth: "300px",
                    overflowY: "auto",
                    maxHeight: "300px",
                    fontSize: "14px",
                  }}
                >
                  <div>
                    <h5>Legend</h5>
                    <div>
                      {elements
                        .filter((legendEl) => legendEl.type === "2")
                        .map((legendEl) => (
                          <div key={legendEl.id} style={{ marginBottom: "10px" }}>
                            {legendEl.content}
                          </div>
                        ))}
                    </div>
                  </div>
                </Rnd>
              )} */}

             {elements.some((el) => el.type === "2") && showLegendContainer && (
                <Rnd
                  key="legend"
                  id="legend-container"
                  default={{
                    x: 10,
                    y: 10,
                    width: "fit-content",
                    height: "fit-content",
                  }}
                  bounds="#map4"
                  style={{
                    position: "absolute",
                    zIndex: 1000,
                    border: "2px solid black",
                    backgroundColor: "rgba(255,255,255,0.85)",
                    padding: "10px 15px",
                    width: "250px",
                    maxWidth: "350px",
                    overflowY: "auto",
                    maxHeight: "300px",
                    fontSize: "14px",
                  }}
                >
                  {/* 🔹 Header with Close Button */}
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <h5 style={{ margin: 0 }}>Legend</h5>
                    <button
                      className="btn cancel"
                      onClick={() => setShowLegendContainer(false)} // ✅ Hide container
                      title="Close legend container"
                    >
                      ×
                    </button>
                  </div>

                  {/* ✅ Show live dynamic legend from addLegend.js */}
                  {legendHtmlItems ? (
                    <div dangerouslySetInnerHTML={{ __html: legendHtmlItems }} />
                  ) : (
                    <p>No dynamic legend available</p>
                  )}
                </Rnd>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
